import React from 'react';
import './ReportDetailsView.css';

const ReportDetailsView = ({ reportData }) => {
    if (!reportData) return <p className="rdv-no-data">No report data available.</p>;

    return (
        <div className="rdv-card">
            <h2 className="rdv-card-title">📋{reportData?.report_name || '—'}</h2>
            <div className="rdv-info-grid">
                {/* <DetailItem label="SHRD ID" value={reportData.SHRD_Id} /> */}
                <DetailItem label="Accepted" value={reportData.SHRD_is_accept === 1 ? 'Yes' : 'No'} />
                {/* <DetailItem label="Description" value={reportData.description} /> */}
                {/* <DetailItem label="Assign Completed" value={reportData.is_assign_completed ? 'Yes' : 'No'} /> */}
                {/* <DetailItem label="Same User" value={reportData.is_same_user ? 'Yes' : 'No'} /> */}
                <DetailItem label="Process" value={reportData.process_status} />
                {/* <DetailItem label="Report Name" value={reportData.report_name} /> */}
                {/* <DetailItem label="Report Status" value={reportData.report_status} /> */}
                {/* <DetailItem label="Schedule ID" value={reportData.scheduleId} /> */}
                <DetailItem label="Schedule Completed" value={reportData.schedule_Iscomplted === 1 ? 'Yes' : 'No'} />
                {/* <DetailItem label="Status" value={reportData.status} /> */}
                <DetailItem label="Assigned By" value={reportData.submitedBy} />
                <DetailItem label="Assigned Date" value={reportData.submitedDate} />
                <DetailItem label="Technology" value={reportData.technology} />
                <DetailItem label="Worksite" value={reportData.worksite} />
            </div>
        </div>
    );
};

const DetailItem = ({ label, value }) => (
    <div className="rdv-info-item">
        <span className="rdv-info-label">{label}:</span>
        <span className="rdv-info-value">{value || '—'}</span>
    </div>
);

export default ReportDetailsView;
